import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

interface ConfirmDeleteModalProps {
  confirmDelete: boolean;
  handleCloseDelete: () => void;
  handleOnDelete: () => void;
}
const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  confirmDelete,
  handleCloseDelete,
  handleOnDelete,
}) => {
  return (
    <React.Fragment>
      <Dialog
        open={confirmDelete}
        // TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseDelete}
        aria-describedby="alert-dialog-slide-description"
      >
        {/* <DialogTitle>{'Delete Constrains confirmation'}</DialogTitle> */}
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Confirmation for Delete
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Do you want to delete this row?
          </DialogContentText>
          <DialogContentText id="alert-dialog-slide-description">
            This record will be deleted only when it is saved.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete}>Cancel</Button>
          <Button onClick={handleOnDelete}>Proceed</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ConfirmDeleteModal;
